var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransportifyWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,4.9l0,5.3h4l0,2.5H17l0,5.9c0.3,1.6,2,2.4,5,2.6h1.5l0,2.1h-2.7c-3.9-0.1-6-1.5-6.3-4.1l0-5.2l-9.6-0.6 l9.6-0.5v-0.6l-14.5-0.9l14.5-0.8V10L4.9,9.5L14.4,9l0-4C14.4,4.9,16.9,4.9,16.9,4.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,24.3c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C19.8,25.2,18.8,24.3,17.6,24.3z  M18.4,26.5c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.3-0.8-0.8c0,0,0,0,0,0c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0 C18,25.7,18.4,26,18.4,26.5C18.4,26.5,18.4,26.5,18.4,26.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,24.8c-1,0-1.8,0.8-1.8,1.7c0,1,0.8,1.7,1.8,1.7c1,0,1.8-0.8,1.8-1.7C24.5,25.6,23.7,24.8,22.7,24.8z  M22.8,27.2c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6C23.4,27,23.1,27.2,22.8,27.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransportifyWhite);
export default __webpack_public_path__ + "static/media/Icon_Transportify_White.6e06f5ddc7bb1f1e9d1cecdb2e97f537.svg";
export { ForwardRef as ReactComponent };